import { Crumb } from "./Crumb";

export class Breadcrumb {
  public crumbs: Crumb[] = [];

  //constructor
  constructor(crumbs: Crumb[] = []) {
    this.crumbs = crumbs.map((crumb) => {
      return  {
        label: crumb.label,
        link: crumb.isActive ? crumb.link : "",
        value: crumb.value,
        isActive: crumb.isActive
      }
    })
  }

}